import React, { useState, useEffect, lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import Header from "./components/Header";
import Body from "./components/Body";
import Contact1 from "./components/Contact1";
import Error from "./components/Error";
import RestroMenu from "./components/RestroMenu";
import UserContext from "./utils/UserContext";
import Cart from "./components/Cart";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router";
import { Provider } from "react-redux";
import appStore from "./utils/appStore";
const About = lazy(() => import("./components/About")); //use it in module level not component level
const AppLayout = () => {
    const [username, setUserName] = useState("");
    useEffect(() => {
        const data = {
            userName: "shashwath",
        };
        setUserName(data.userName);
    }, []);
    return (
        <>
            <Provider store={appStore}>
                <UserContext.Provider value={{ defaultUser: username, setUserName }}>
                    {/* <div className="app"> */}
                    <Header />
                    <Outlet />
                    {/* </div> */}
                </UserContext.Provider>
            </Provider>
        </>
    );
};
const appRouter = createBrowserRouter([
    {
        path: "/",
        element: <AppLayout />,
        children: [
            {
                path: "/",
                element: <Body />,
            },
            {
                path: "/about",
                element: (
                    <Suspense fallback={<h1>Loading...</h1>}>
                        <About />
                    </Suspense>
                ),
            },
            {
                path: "/contact",
                element: <Contact1 />,
            },
            {
                path: "/restaurant/:resId",
                element: <RestroMenu />,
            },
            {
                path: "/cart",
                element: <Cart />,
            },
        ],
        errorElement: <Error />,
    },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={appRouter} />);
